import React, { useState, useEffect } from "react";
import BreadCrumb from "../BreadCrumb";
import Layout from "../Layout";
import { useDispatch, useSelector } from "react-redux";
import PageLoader from "../../common/Loader";
import { fetchYearsList, studentHistoryAction } from "../../redux/actions/studentActions";
import StudentHistory from "../Student/Edit/studentHisory";
const StudentDashboard = (props) => {
  const dispatch = useDispatch();
  const { userDetails } = useSelector((state) => state.user);
  const { loader } = useSelector((state) => state.student);
  const [sideMenu, setSideMenu] = useState(true);
  
  const onSideMenu = (value) => {
    setSideMenu(value);
  };

  useEffect(() => {
    async function fetchDashboardDetails() {
        await dispatch(studentHistoryAction({StudentId: userDetails.StudentId}))
    }

    fetchDashboardDetails();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="">
      <Layout onClick={onSideMenu} />
      <PageLoader loader={loader}>
        <div
          className={`main-content d-flex flex-column ${
            sideMenu ? "" : "hide-sidemenu"
          }`}
        >
          <div className="main-content-header">
            <BreadCrumb />
          </div>
          <div className="spacer">
              <h3>Student History</h3>
            <StudentHistory /> 
          </div>
        </div>
      </PageLoader>
    </div>
  );
};

export default StudentDashboard;
